<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 3.28988V3C14 1.89543 13.1046 1 12 1C10.8954 1 10 1.89543 10 3V3.28988C7.10851 4.15043 5 6.82898 5 10V17H4V19H20V17H19V10C19 6.82898 16.8915 4.15043 14 3.28988ZM14 20V21C14 22.1046 13.1046 23 12 23C10.8954 23 10 22.1046 10 21V20H14ZM6 1.28979C3.10851 2.15034 1 4.8289 1 7.99992V8.99992H3V7.99992C3 5.9496 4.2341 4.18752 6 3.41596V1.28979ZM23 7.99992C23 4.8289 20.8915 2.15034 18 1.28979V3.41596C19.7659 4.18752 21 5.9496 21 7.99992V8.99992H23V7.99992Z"
  />
</template>
